import StoredPartPreview from './StoredPartPreview';
import {ShoppingCart} from 'lucide-react';

export default function OrderLinePreview({line}) {
  if(line.operations?.purchase&&line.operations?.laser===false&&line.operations.purchase.item_type!=='blankPlate')return <div className="flex h-14 w-20 shrink-0 flex-col items-center justify-center gap-1 rounded-lg border border-slate-300 bg-slate-50 p-1 text-center text-[10px] text-slate-500" title="No laser geometry required"><ShoppingCart className="h-4 w-4" aria-hidden="true"/><span>Purchased item</span></div>;
  // Accepted lines and their source audit are frozen order data; never fetch
  // current quote drawings or manufacture holes from bounding dimensions.
  const source=line.price_audit?.source_snapshot||line.frozen_source||{};
  return <StoredPartPreview part={{...line,frozen_source:source}}/>;
}
